/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-29 17:35:59
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\trace\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 溯源管理列表数据查询或查询溯源列表客户查询/产品查询内层UDI
export function getTraceabilityData(params) {
  return request({
    url: '/wms/udiHistory/list',
    method: 'get',
    params
  })
}

export function getTraceabilityDataByProductName(params) {
  return request({
    url: '/wms/udiHistory/listOrderProduct',
    method: 'get',
    params
  })
}

export function getTraceabilityDataByCustomerName(params) {
  return request({
    url: '/wms/udiHistory/listOrder',
    method: 'get',
    params
  })
}
